import { makeStyles } from '@material-ui/core/styles'

export const useRichTextEditorStyles = makeStyles(theme => ({
  editorWrapper: {
    '& .ql-toolbar.ql-snow': {
      borderRadius: '8px 8px 0 0',
      border: '1px solid #ced4da',
      backgroundColor: theme.palette.background.paper
    },
    '& .ql-container.ql-snow': {
      borderRadius: '0 0 8px 8px',
      border: '1px solid #ced4da',
      borderTop: 'none',
      fontSize: 12,
      lineHeight: '18px',
      minHeight: 160,
      backgroundColor: theme.palette.background.paper
    },
    '& .ql-editor': {
      minHeight: 160,
      color: theme.palette.mpSkladSecondary.darkBlue1
    },
    '& .ql-editor.ql-blank::before': {
      color: theme.palette.text.secondary,
      fontStyle: 'normal'
    }
  },
  editorError: {
    '& .ql-toolbar.ql-snow, & .ql-container.ql-snow': {
      borderColor: theme.palette.error.main
    }
  }
}))
